import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header/Header";
import About from "./pages/About Company/About/About";
import FAQ from "./pages/About Company/FAQ/FAQ";
import Footer from "./components/Footer/Footer";
import Contact from "./pages/contact-us/Contact/Contact";
import BankingLicense from "./pages/Services/banking-license/BankingLicense";
import ContactForm from "./pages/contact-us/Contact Form/contactForm";
import OurServices from "./components/OurServices/OurServices";
import HomeFooter from "./components/home/home-footer/HomeFooter";
import Newsletter from "./pages/NewsletterPage/NewsletterPage";
import Home from "./pages/home/Home";
import AnjouanGamingLicenseBlog from "./pages/blog/AnjouanGamingLicenseBlog";
import WesternGamingLicenseBlog from "./pages/blog/WesternGamingLicenseBlog";
import ScrollToTop from "./utils/ScrollToTop";
import Blog from "./pages/blog/Blog";
import {AuthProvider} from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/login/login";
import Dashboard from "./pages/dashboard/dashboard";
import DashboardLayout from "./pages/dashboard/DashboardLayout";
import BlogsList from "./pages/dashboard/blogList/BlogsList";
import BlogDetail from "./pages/dashboard/blogDetail/BlogDetail";
import AddBlog from "./pages/dashboard/addBlog/addBlog";
import WesternSaharaIBC from "./pages/Area/ibc/WesternSaharaIBC";
import MwaliIBC from "./pages/Area/ibc/MwaliIBC";
import AnjouanIBC from "./pages/Area/ibc/AnjouanIBC";
import WesternSaharaBankingLicense from "./pages/Services/banking-license/WesternSaharaBankingLicense";
import BankingLicenseMwali from "./pages/Services/banking-license/BankingLicenseMwali";
import BankingLicenseMalta from "./pages/Services/banking-license/BankingLicenseMalta";
import BankingLicenseCyprus from "./pages/Services/banking-license/BankingLicenseCyprus";
import BankingLicensePanama from "./pages/Services/banking-license/BankingLicensePanama";
import IsleManBankingFinTechLicense from "./pages/Services/banking-license/IsleManBankingFintechLicense";
import BankingLicenseSeychelles from "./pages/Services/banking-license/BankingLicenseSeychelles";
import BankingLicenseMauritius from "./pages/Services/banking-license/BankingLicenseMauritius";
import BankingLicenseSaintLucia from "./pages/Services/banking-license/BankingLicenseSaintLucia";
import WhyOffshoreAdvisory from "./pages/About Company/WhyOffshoreAdvisory/WhyOffshoreAdvisory";
import ClientTestimonials from "./pages/About Company/ClientTestimonials/ClientTestimonials";
import GamingLicenseServices from "./pages/Services/gaming-license/gaming-license-services";
import IGamingGamblingWesternSahara from "./pages/Services/iGaming-gambling/iGamingGamblingWesternSahara";
import GamingLicenseMwali from "./pages/Services/gaming-license/gaming-license-Mwali(Comoros)";
import GamingLicenseAnjouan from "./pages/Services/gaming-license/GamingLicenseAnjouan";
import GibraltariGamingLicense from "./pages/Services/iGaming-gambling/GibraltariGamingLicense";
import GamingiGamingLicenseMalta from "./pages/Services/iGaming-gambling/GamingiGamingLicenseMalta";
import GamingBettingLicenseCyprus from "./pages/Services/iGaming-gambling/GamingBettingLicenseCyprus";
import GamingLicensePanama from "./pages/Services/iGaming-gambling/GamingLicensePanama";
import CuraçaoGamingLicense from "./pages/Services/iGaming-gambling/CuraçaoGamingLicense";
import GamingiGamingLicenseSeychelles from "./pages/Services/iGaming-gambling/GamingiGamingLicenseSeychelles";
import GamingBettingLicenseSaintLucia from "./pages/Services/iGaming-gambling/GamingBettingLicenseSaintLucia";
import BrokerageForexLicenses from "./pages/Services/forex-brokerage-license/BrokerageForexLicenses";
import ForexBrokerageLicenseWesternSahara
    from "./pages/Services/forex-brokerage-license/ForexBrokerageLicenseWesternSahara";
import ForexBrokerageLicenseMwali from "./pages/Services/forex-brokerage-license/ForexBrokerageLicenseMwali";
import BrokerageLicenseAnjouan from "./pages/Services/forex-brokerage-license/BrokerageLicenseAnjouan";
import BrokerageForexLicenseMalta from "./pages/Services/forex-brokerage-license/BrokerageForexLicenseMalta";
import ForexBrokerageLicenseCyprus from "./pages/Services/forex-brokerage-license/ForexBrokerageLicenseCyprus";
import SecuritiesDealerLicenseSeychelles
    from "./pages/Services/forex-brokerage-license/SecuritiesDealerLicenseSeychelles";
import ForexBrokerageVincentGrenadines from "./pages/Services/forex-brokerage-license/ForexBrokerageVincentGrenadines";
import FinancialLicenseAnjouan from "./pages/Services/FinancialLicenseAnjouan";
import GibraltarBankingFinTechLicense from "./pages/Services/GibraltarBankingFinTechLicense";
import CryptoVirtualAssetLicenses from "./pages/Services/crypto/CryptoVirtualAssetLicenses";
import CryptoLicenseWesternSahara from "./pages/Services/crypto/CryptoLicenseWesternSahara";
import CryptoLicenseMwali from "./pages/Services/crypto/CryptoLicenseMwali";
import CryptoLicenseAnjouan from "./pages/Services/crypto/CryptoLicenseAnjouan.js";
import GibraltarCryptoDLTLicense from "./pages/Services/crypto/GibraltarCryptoDLTLicense";
import CryptoBlockchainLicenseMalta from "./pages/Services/crypto/CryptoBlockchainLicenseMalta";
import CryptoBlockchainLicenseCyprus from "./pages/Services/crypto/CryptoBlockchainLicenseCyprus";
import CryptoLicensePanama from "./pages/Services/crypto/CryptoLicensePanama";
import CryptoDigitalAssetLicenseSeychelles from "./pages/Services/crypto/CryptoDigitalAssetLicenseSeychelles";
import CryptoVASPLicenseMauritius from "./pages/Services/crypto/CryptoVASPLicenseMauritius";
import TrustInsuranceLicenses from "./pages/Services/Trust & Insurance Licenses/TrustInsuranceLicenses";
import TrustInsuranceLicensesWesternSahara
    from "./pages/Services/Trust & Insurance Licenses/TrustInsuranceLicensesWesternSahara";
import TrustInsuranceLicensesMwali from "./pages/Services/Trust & Insurance Licenses/TrustInsuranceLicensesMwali";
import TrustInsuranceLicensesAnjouan from "./pages/Services/Trust & Insurance Licenses/TrustInsuranceLicensesAnjouan";
import GibraltarInsuranceReinsuranceLicense
    from "./pages/Services/Trust & Insurance Licenses/GibraltarInsuranceReinsuranceLicense";
import InsuranceReinsuranceLicenseMalta
    from "./pages/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseMalta";
import InsuranceReinsuranceLicenseCyprus
    from "./pages/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseCyprus";
import InsuranceCaptivesIsleMan from "./pages/Services/Trust & Insurance Licenses/InsuranceCaptivesIsleMan";
import InsuranceReinsuranceLicenseMauritius
    from "./pages/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseMauritius";
import InsuranceReinsuranceLicenseSaintLucia
    from "./pages/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseSaintLucia";
import InsuranceReinsuranceLicenseSeychelles
    from "./pages/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseSeychelles";
import GibraltarFundsAssetManagementLicense from "./pages/Services/fund-asset/GibraltarFundsAssetManagementLicense";
import FundsAssetManagementIsleMan from "./pages/Services/fund-asset/FundsAssetManagementIsleMan";
import FundsAssetManagementLicenseMalta from "./pages/Services/fund-asset/FundsAssetManagementLicenseMalta";
import FundsAssetManagementLicensePanama from "./pages/Services/fund-asset/FundsAssetManagementLicensePanama";
import AssetManagementLicenseMwali from "./pages/Services/fund-asset/AssetManagementLicenseMwali";
import FundsAssetManagementLicenseMauritius from "./pages/Services/fund-asset/FundsAssetManagementLicenseMauritius";
import AssetManagementLicenseWesternSahara from "./pages/Services/fund-asset/AssetManagementLicenseWesternSahara";
import PaymentsFinTechLicenses from "./pages/Services/payments-finTech-licenses/PaymentsFinTechLicenses";
import PaymentServicesEMILicenseMalta from "./pages/Services/payments-finTech-licenses/PaymentServicesEMILicenseMalta";
import PaymentServicesEMILicenseCyprus
    from "./pages/Services/payments-finTech-licenses/PaymentServicesEMILicenseCyprus";
import PaymentsFinTechLicenseMauritius
    from "./pages/Services/payments-finTech-licenses/PaymentsFinTechLicenseMauritius";
import PaymentsFinTechLicenseSeychelles
    from "./pages/Services/payments-finTech-licenses/PaymentsFinTechLicenseSeychelles";
import FinTechPaymentsLicensePanama from "./pages/Services/payments-finTech-licenses/FinTechPaymentsLicensePanama";
import OffshoreCompanyFormation from "./pages/company-formation/offshore-company-formation/OffshoreCompanyFormation";
import CyprusCompanyFormation from "./pages/company-formation/CyprusCompanyFormation";
import STLuciaCompanyFormation from "./pages/company-formation/St.LuciaCompanyFormation";
import UKCompanyFormation from "./pages/company-formation/UKCompanyFormation";
import IndonesiaCompanyFormation from "./pages/company-formation/IndonesiaCompanyFormation";
import PanamaCompanyFormation from "./pages/company-formation/PanamaCompanyFormation";
import MaltaCompanyFormation from "./pages/company-formation/MaltaCompanyFormation";
import MauritiusCompanyFormation from "./pages/company-formation/MauritiusCompanyFormation";
import IsleManCompanyFormation from "./pages/company-formation/IsleManCompanyFormation";
import StVincentCompanyFormation from "./pages/company-formation/StVincentCompanyFormation";
import UAECompanyFormation from "./pages/company-formation/UAECompanyFormation";
import SingaporeCompanyFormation from "./pages/company-formation/SingaporeCompanyFormation";
import CompanyFormationSeychelles from "./pages/company-formation/CompanyFormationSeychelles";
import CompanyFormationDominica from "./pages/company-formation/CompanyFormationDominica";
import ResidencyPassport from "./pages/residency-passport/ResidencyPassport";
import ResidencyInvestmentUAE from "./pages/residency-passport/ResidencyInvestmentUAE";
import GoldenVisaSpain from "./pages/residency-passport/GoldenVisaSpain";
import GoldenVisaItaly from "./pages/residency-passport/GoldenVisaItaly";
import ResidencyIndonesia from "./pages/residency-passport/ResidencyIndonesia";
import ResidencyInvestmentCyprus from "./pages/residency-passport/ResidencyInvestmentCyprus";
import ResidencyCitizenshipDominica from "./pages/residency-passport/ResidencyCitizenshipDominica";
import RealEstateInvestment from "./pages/real-estate/RealEstateInvestment";
import RealEstateInvestmentUAE from "./pages/real-estate/RealEstateInvestmentUAE";
import RealEstateInvestmentBaliIndonesia from "./pages/real-estate/RealEstateInvestmentBaliIndonesia";
import RealEstateInvestmentSpain from "./pages/real-estate/RealEstateInvestmentSpain";
import RealEstateInvestmentCyprus from "./pages/real-estate/RealEstateInvestmentCyprus";
import RealEstateInvestmentItaly from "./pages/real-estate/RealEstateInvestmentItaly";
import RealEstateInvestmentGreece from "./pages/real-estate/RealEstateInvestmentGreece";
import NonDomTaxRegime from "./pages/NonDomTaxRegime/NonDomTaxRegime";
import ItalyNonDomTaxRegime from "./pages/NonDomTaxRegime/ItalyNonDomTaxRegime";
import UKNonDomiciledTaxRegime from "./pages/NonDomTaxRegime/UKNonDomiciledTaxRegime";
import OffshoreBankAccountOpening from "./pages/offshore-bank-account-opening/OffshoreBankAccountOpening";
import FintechServices from "./pages/fintech-services/fintech-services";
import FinancialLicense from "./pages/financial-license/FinancialLicense";
import ReadyMade from "./pages/Area/ready-made/ReadyMade";
import AssetProtectionServices from "./pages/asset-protection-services/AssetProtectionServices";
import WesternSaharaJurisdiction from "./pages/Jurisdictions/WesternSaharaJurisdiction";
import ReadyMadeCompaniesWesternSahara from "./pages/Area/ready-made/ReadyMadeCompaniesWesternSahara";
import MwaliJurisdiction from "./pages/Jurisdictions/MwaliJurisdiction";
import AnjouanJurisdiction from "./pages/Jurisdictions/AnjouanJurisdiction";
import CompanyFormationGibraltar from "./pages/company-formation/CompanyFormationGibraltar";
import ResidencyInvestmentGibraltar from "./pages/residency-passport/ResidencyInvestmentGibraltar";
import GibraltarTrustsPrivateWealth from "./pages/Services/Trust & Insurance Licenses/GibraltarTrustsPrivateWealth";
import IsleManJurisdiction from "./pages/Jurisdictions/IsleManJurisdiction";
import ResidencyInvestmentIsleMan from "./pages/residency-passport/ResidencyInvestmentIsleMan";
import MaltaJurisdiction from "./pages/Jurisdictions/MaltaJurisdiction";
import CyprusJurisdiction from "./pages/Jurisdictions/CyprusJurisdiction";
import PanamaJurisdiction from "./pages/Jurisdictions/PanamaJurisdiction";
import TrustCompanyLicensePanama from "./pages/Services/Trust & Insurance Licenses/TrustCompanyLicensePanama";
import MaritimeShippingLicensesPanama from "./pages/Services/MaritimeShippingLicensesPanama";
import ResidencyCitizenshipInvestmentSaintLucia
    from "./pages/residency-passport/ResidencyCitizenshipInvestmentSaintLucia";
import SeychellesJurisdiction from "./pages/Jurisdictions/SeychellesJurisdiction";
import MauritiusJurisdiction from "./pages/Jurisdictions/MauritiusJurisdiction";
import CuraçaoJurisdiction from "./pages/Jurisdictions/CuraçaoJurisdiction";
import StVincentJurisdiction from "./pages/Jurisdictions/StVincentJurisdiction";
import UnitedArabEmiratesJurisdiction from "./pages/Jurisdictions/UnitedArabEmiratesJurisdiction";
import UnitedKingdomJurisdiction from "./pages/Jurisdictions/UnitedKingdomJurisdiction";
import SingaporeJurisdiction from "./pages/Jurisdictions/SingaporeJurisdiction";
import IndonesiaJurisdiction from "./pages/Jurisdictions/IndonesiaJurisdiction";
import GreeceJurisdiction from "./pages/Jurisdictions/GreeceJurisdiction";
import SpainJurisdiction from "./pages/Jurisdictions/SpainJurisdiction";
import ItalyJurisdiction from "./pages/Jurisdictions/ItalyJurisdiction";
import DominicaJurisdiction from "./pages/Jurisdictions/DominicaJurisdiction";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Main />
            </BrowserRouter>
        </AuthProvider>
    );
}
function Main() {
    const { pathname } = useLocation();

    // Normalize to avoid trailing slash edge cases
    const cleanPath = pathname.replace(/\/+$/, '') || '/';

    const isHome = cleanPath === '/';
    const isContact = cleanPath === '/contact';
    const isSubscribe = cleanPath === '/subscribe';

    // Hide on all blog routes
    const isBlog = cleanPath.startsWith('/blog') || cleanPath.includes('blog');

    // Dashboard routes
    const isDashboard = cleanPath.startsWith('/dashboard');

    // Login route
    const isLogin = cleanPath.startsWith('/login');


    
   const hideComponentsPages = [
        '/',
        '/about',
        '/faq',
        '/why-offshore-advisory',
        '/client-testimonials',
        '/contact',
        '/newsletter'
    ];

    const isContactPage = cleanPath === '/contact';
    const shouldHideComponents = hideComponentsPages.includes(cleanPath);
    return (
        <>
            <ScrollToTop/>

            {/* ✅ Hide header on login page */}
            {!isLogin && !isDashboard && <Header />}

            <Routes>

                <Route path="/" element={
                    <>
                        <Home/>
                        
                    </>
                } />

                {/* newsletter */}
                <Route path="/newsletter" element={<Newsletter/>} />

                {/* ABOUT THE COMPANY */}
                <Route path="/about" element={<About />} />
                <Route path="/why-offshore-advisory" element={<WhyOffshoreAdvisory/>} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/client-testimonials" element={<ClientTestimonials />} />


                {/* GAMING LICENSES */}
                <Route path='/gaming-license-services' element={<GamingLicenseServices/>} />
                <Route path="/igaming-gambling-western-sahara" element={<IGamingGamblingWesternSahara/>} />
                <Route path='/gaming-license-mwali' element={<GamingLicenseMwali/>} />
                <Route path='/gaming-license-anjouan' element={<GamingLicenseAnjouan/>} />
                <Route path="/gibraltar-igaming-license" element={<GibraltariGamingLicense/>} />
                <Route path="/gaming-igaming-license-malta" element={<GamingiGamingLicenseMalta/>} />
                <Route path="/gaming-betting-license–cyprus" element={<GamingBettingLicenseCyprus/>} />
                <Route path="/gaming-license–panama" element={<GamingLicensePanama/>} />
                <Route path="/curaçao-gaming-license" element={<CuraçaoGamingLicense/>} />
                <Route path="/gaming-igaming-license–seychelles" element={<GamingiGamingLicenseSeychelles/>} />
                <Route path="/gaming-betting-license–saint-lucia" element={<GamingBettingLicenseSaintLucia/>} />

                {/* forex and brokerage license */}
                <Route path="/brokerage-forex-licenses" element={<BrokerageForexLicenses/>} />
                <Route path="/forex-brokerage-license-western-sahara" element={<ForexBrokerageLicenseWesternSahara/>} />
                <Route path="/forex-brokerage-license-mwali" element={<ForexBrokerageLicenseMwali/>} />
                <Route path="/brokerage-license-anjouan" element={<BrokerageLicenseAnjouan/>} />
                <Route path="/brokerage-forex-license-malta" element={<BrokerageForexLicenseMalta/>} />
                <Route path="/forex-brokerage-license-cyprus" element={<ForexBrokerageLicenseCyprus/>} />
                <Route path="/securities-dealer-license-seychelles" element={<SecuritiesDealerLicenseSeychelles/>} />
                <Route path="/forex-brokerage-St-vincent-grenadines" element={<ForexBrokerageVincentGrenadines/>} />


                {/* banking license */}
                <Route path="/banking-license" element={<BankingLicense/>} />
                <Route path="/banking-license-malta" element={<BankingLicenseMalta/>} />
                <Route path="/banking-license-cyprus" element={<BankingLicenseCyprus/>} />
                <Route path="/banking-license-panama" element={<BankingLicensePanama/>} />
                <Route path="/banking-license-seychelles" element={<BankingLicenseSeychelles/>} />
                <Route path="/banking-license-mauritius" element={<BankingLicenseMauritius/>} />
                <Route path="/banking-license-saint-lucia" element={<BankingLicenseSaintLucia/>} />
                <Route path="/western-sahara-banking-license" element={<WesternSaharaBankingLicense />} />
                <Route path="/banking-license-mwali" element={<BankingLicenseMwali/>} />


                <Route path="/financial-license-anjouan" element={<FinancialLicenseAnjouan />} />
                <Route path="/gibralta-banking-finTech-license" element={<GibraltarBankingFinTechLicense />} />
                <Route path="/isle-man-banking-fintech-license" element={<IsleManBankingFinTechLicense/>} />


                {/* crypto & blockchain */}
                <Route path="/crypto-virtual-asset-licenses" element={<CryptoVirtualAssetLicenses/>} />
                <Route path="/crypto-license-western-sahara" element={<CryptoLicenseWesternSahara/>} />
                <Route path="/crypto-license-mwali" element={<CryptoLicenseMwali/>} />
                <Route path="/crypto-license-anjouan" element={<CryptoLicenseAnjouan/>} />
                <Route path="/gibraltar-crypto-dlt-license" element={<GibraltarCryptoDLTLicense/>} />
                <Route path="/crypto-blockchain-license-malta" element={<CryptoBlockchainLicenseMalta/>} />
                <Route path="/crypto-blockchain-license-cyprus" element={<CryptoBlockchainLicenseCyprus/>} />
                <Route path="/crypto-license-panama" element={<CryptoLicensePanama/>} />
                <Route path="/crypto-digital-asset-license-seychelles" element={<CryptoDigitalAssetLicenseSeychelles/>} />
                <Route path="/Crypto-vasp-license-mauritius" element={<CryptoVASPLicenseMauritius/>} />


                {/* Trust Insurance Licenses */}
                <Route path="/trust-insurance-licenses" element={<TrustInsuranceLicenses/>} />
                <Route path="/trust-insurance-licenses-western-sahara" element={<TrustInsuranceLicensesWesternSahara/>} />
                <Route path="/trust-insurance-licenses-mwali" element={<TrustInsuranceLicensesMwali/>} />
                <Route path="/trust-insurance-licenses-anjouan" element={<TrustInsuranceLicensesAnjouan/>} />
                <Route path="/gibraltar-insurance-reinsurance-license" element={<GibraltarInsuranceReinsuranceLicense/>} />
                <Route path="/insurance-reinsurance-license-malta" element={<InsuranceReinsuranceLicenseMalta/>} />
                <Route path="/insurance-reinsurance-cyprus" element={<InsuranceReinsuranceLicenseCyprus/>} />
                <Route path="/insurance-reinsurance-license-panama" element={<CryptoBlockchainLicenseCyprus/>} />
                <Route path="/insurance-captives-isle-man" element={<InsuranceCaptivesIsleMan/>} />
                <Route path="/insurance-reinsurance-license-mauritius" element={<InsuranceReinsuranceLicenseMauritius/>} />
                <Route path="/insurance-reinsurance-license-saint-lucia" element={<InsuranceReinsuranceLicenseSaintLucia/>} />
                <Route path="/insurance-reinsurance-license-seychelles" element={<InsuranceReinsuranceLicenseSeychelles/>} />
                <Route path="/gibraltar-funds-asset-management-license" element={<GibraltarFundsAssetManagementLicense/>} />
                <Route path="/gibraltar-trusts-private-wealth" element={<GibraltarTrustsPrivateWealth/>} />
                <Route path="/trust-company-license-panama" element={<TrustCompanyLicensePanama/>} />

                <Route path="/maritime-shipping-license-panama" element={<MaritimeShippingLicensesPanama/>} />

                {/* fund & asset */}
                <Route path="/funds-asset-management-isle-man" element={<FundsAssetManagementIsleMan/>} />
                <Route path="/funds-asset-management-license-malta" element={<FundsAssetManagementLicenseMalta/>} />
                <Route path="/funds-asset-management-license-cyprus" element={<CryptoBlockchainLicenseCyprus/>} />
                <Route path="/funds-asset-management-license-panama" element={<FundsAssetManagementLicensePanama/>} />
                <Route path="/asset-management-license-mwali" element={<AssetManagementLicenseMwali/>} />
                <Route path="/funds-asset-management-license-mauritius" element={<FundsAssetManagementLicenseMauritius/>} />
                <Route path="/asset-management-license-western-sahara" element={<AssetManagementLicenseWesternSahara/>} />

                {/* payment and fintech */}
                <Route path="/payments-fintech-licenses" element={<PaymentsFinTechLicenses/>} />
                <Route path="/gibraltar-banking-finTech-license" element={<GibraltarBankingFinTechLicense/>} />
                <Route path="/payment-services-EMI-license-malta" element={<PaymentServicesEMILicenseMalta/>} />
                <Route path="/payment-services-EMI-license-cyrus" element={<PaymentServicesEMILicenseCyprus/>} />
                <Route path="/payments-fintech-license-mauritius" element={<PaymentsFinTechLicenseMauritius/>} />
                <Route path="/payments-fintech-license-seychelles" element={<PaymentsFinTechLicenseSeychelles/>} />
                <Route path="/payments-fintech-license-panama" element={<FinTechPaymentsLicensePanama/>} />

                {/* COMPANY FORMATION */}
                <Route path="/offshore-company-formation" element={<OffshoreCompanyFormation/>} />
                <Route path="/western-sahara-ibc" element={<WesternSaharaIBC/>} />
                <Route path="/mwali-ibc" element={<MwaliIBC/>} />
                <Route path="/anjouan-ibc" element={<AnjouanIBC/>} />
                <Route path="/cyprus-company-formation" element={<CyprusCompanyFormation/>} />
                <Route path="/st-lucia-company-formation" element={<STLuciaCompanyFormation/>} />
                <Route path="/uk-company-formation" element={<UKCompanyFormation/>} />
                <Route path="/indonesia-company-formation" element={<IndonesiaCompanyFormation/>} />
                <Route path="/panama-company-formation" element={<PanamaCompanyFormation/>} />
                <Route path="/malta-company-formation" element={<MaltaCompanyFormation/>} />
                <Route path="/mauritius-company-formation" element={<MauritiusCompanyFormation/>} />
                <Route path="/isle-man-company-formation" element={<IsleManCompanyFormation/>} />
                <Route path="/st-vincent-company-formation" element={<StVincentCompanyFormation/>} />
                <Route path="/uae--company-formation" element={<UAECompanyFormation/>} />
                <Route path="/singapore-company-formation" element={<SingaporeCompanyFormation/>} />
                <Route path="/seychelles-company-formation" element={<CompanyFormationSeychelles/>} />
                <Route path="/dominica-company-formation" element={<CompanyFormationDominica/>} />
                <Route path="/company-formation-gibraltar" element={<CompanyFormationGibraltar/>} />

                {/* residency and passport */}
                <Route path='/residency-passport' element={<ResidencyPassport/>} />
                <Route path='/residency-investment-uaet' element={<ResidencyInvestmentUAE/>} />
                <Route path='/golden-visa-spain' element={<GoldenVisaSpain/>} />
                <Route path='/golden-visa-italy' element={<GoldenVisaItaly/>} />
                <Route path='/residency-indonesia' element={<ResidencyIndonesia/>} />
                <Route path='/residency-investment-cyprus' element={<ResidencyInvestmentCyprus/>} />
                <Route path='/residency-citizenship-dominica' element={<ResidencyCitizenshipDominica/>} />
                <Route path='/residency-investment-gibraltar' element={<ResidencyInvestmentGibraltar/>} />
                <Route path='/residency-investment-isle-man' element={<ResidencyInvestmentIsleMan/>} />
                <Route path='/residency-citizenship-investment-saint-lucia' element={<ResidencyCitizenshipInvestmentSaintLucia/>} />


                {/* real estate  */}
                <Route path="/real-estate-investment" element={<RealEstateInvestment />} />
                <Route path="/real-estate-investment-uae" element={<RealEstateInvestmentUAE />} />
                <Route path="/real-estate-investment-bali-indonesia" element={<RealEstateInvestmentBaliIndonesia />} />
                <Route path="/real-estate-investment-spain" element={<RealEstateInvestmentSpain />} />
                <Route path="/real-estate-investment-cyprus" element={<RealEstateInvestmentCyprus />} />
                <Route path="/real-estate-investment-italy" element={<RealEstateInvestmentItaly />} />
                <Route path="/real-estate-investment-greece" element={<RealEstateInvestmentGreece />} />

                {/* financial & advisory  */}
                <Route path="/offshore-bank-account-opening" element={<OffshoreBankAccountOpening />} />
                <Route path="/fintech-services" element={<FintechServices />} />
                <Route path="/financial-license" element={<FinancialLicense />} />
                {/* ready made */}
                <Route path="/ready-made" element={<ReadyMade />} />
                <Route path="/ready-made-companies-corporate-bank-accounts" element={<ReadyMade />} />
                <Route path="/ready-made-companies-western-sahara" element={<ReadyMadeCompaniesWesternSahara />} />
                <Route path="/assets-protection" element={<AssetProtectionServices />} />

                {/* non dom  */}
                <Route path="/non-dom-tax-regime" element={<NonDomTaxRegime />} />
                <Route path="/uk-non-domiciled-tax-regime" element={<UKNonDomiciledTaxRegime />} />
                <Route path="/ital-non-dom-tax-regime" element={<ItalyNonDomTaxRegime />} />

                {/* jurisdictions */}
                <Route path="/western-sahara-jurisdiction" element={<WesternSaharaJurisdiction />} />
                <Route path="/mwali-jurisdiction" element={<MwaliJurisdiction />} />
                <Route path="/anjouan-jurisdiction" element={<AnjouanJurisdiction />} />
                <Route path="/isle-man-jurisdiction" element={<IsleManJurisdiction />} />
                <Route path="/malta-jurisdiction" element={<MaltaJurisdiction />} />
                <Route path="/cyprus-jurisdiction" element={<CyprusJurisdiction />} />
                <Route path="/panama-jurisdiction" element={<PanamaJurisdiction />} />
                <Route path="/seychelles-jurisdiction" element={<SeychellesJurisdiction />} />
                <Route path="/mauritius-jurisdiction" element={<MauritiusJurisdiction />} />
                <Route path="/curaçao-jurisdiction" element={<CuraçaoJurisdiction />} />
                <Route path="/st-vincent-jurisdiction" element={<StVincentJurisdiction />} />
                <Route path="/united-arab-emirates-jurisdiction" element={<UnitedArabEmiratesJurisdiction />} />
                <Route path="/united-kingdom-jurisdiction" element={<UnitedKingdomJurisdiction />} />
                <Route path="/singapore-jurisdiction" element={<SingaporeJurisdiction />} />
                <Route path="/indonesia-jurisdiction" element={<IndonesiaJurisdiction />} />
                <Route path="/greece-jurisdiction" element={<GreeceJurisdiction />} />
                <Route path="/spain-jurisdiction" element={<SpainJurisdiction />} />
                <Route path="/italy-jurisdiction" element={<ItalyJurisdiction />} />
                <Route path="/dominica-jurisdiction" element={<DominicaJurisdiction />} />

                {/* CONTACT */}
                <Route path="/contact" element={<Contact />} />

                {/* BLOG */}
                <Route path="/blogs" element={<Blog/>} />
                <Route path="/anjouan-gaming-license-blog" element={<AnjouanGamingLicenseBlog />} />
                <Route path="/western-sahra-gaming-license-blog" element={<WesternGamingLicenseBlog/>} />

                {/* DASHBOARD ROUTES element={<DashboardLayout />*/}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <DashboardLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Dashboard />} />
                    <Route path='blog-list' element={<BlogsList/>} />
                    <Route path="blog/:id" element={<BlogDetail />} />
                    <Route path="add-blog" element={<AddBlog/>} />
                </Route>

                {/* login */}
                <Route path='/login' element={<Login/>}/>

            </Routes>

            {/* Условный рендеринг компонентов */}
            {!isDashboard && !isLogin && (
                <>
                    {/* Страница контактов - особый порядок */}
                    
                    
                    {/* Остальные страницы - обычный порядок, кроме указанных и блогов */}
                    {!isContactPage && !shouldHideComponents && !isBlog && (
                        <>
                            <OurServices />
                            <ContactForm />
                        </>
                    )}
                    
                    {/* Футер показываем всегда */}
                    <Footer />
                </>
            )}
        </>
    );
}

export default App;